
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/longrangemovers",
      function () {
        return require("private-next-pages/longrangemovers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/longrangemovers"])
      });
    }
  